import React from 'react';
import isNil from 'lodash/isNil';
import {
  useFormContext,
} from 'react-hook-form';
import Controller from 'core/components/FormController';
import Accordion from 'core/components/Accordion';
import Input from 'pages/Dashboard/components/Input';
import Wrapper from 'pages/Dashboard/components/Input/Wrapper';
import {
  validatePhone,
  validatePhoneIfSet,
  validateEmailIfSet,
} from 'pages/Dashboard/utils/helper';
import CallForCCMButton from 'pages/Dashboard/pages/Charts/pages/Details/components/Demographics/CallForCCMButton';
import SendPCCReminderButton from 'pages/Dashboard/pages/Charts/pages/Details/components/Demographics/SendPCCReminderButton';
import PhoneInputWrapper from 'core/components/PhoneInputWrapper';
import {
  useGetPhoneNumberTag,
} from 'pages/Dashboard/pages/Charts/pages/Details/hooks';
import {
 usePCCAvailability,
} from 'views/EMR/hooks/pcc';

export default function PatientContactInfo() {
  const {
    control,
    watch,
  } = useFormContext();
  const patientId = watch('patientId');
  const phoneNumber = watch('phoneNumber.phoneNumberWithAreaCode');
  const { isPCCAvailable, isCcmAvailable } = usePCCAvailability();

  const {
    phoneTag: primaryPhoneTag,
    isLoading: isLoadingPhoneTag,
  } = useGetPhoneNumberTag(phoneNumber);

  return (
    <Accordion
      defaultExpanded
      header="Contact Information"
      headerActions={(
        (isCcmAvailable || isPCCAvailable) ? (
          <>
            {isCcmAvailable ? (
              <CallForCCMButton
                patientId={patientId ?? 0}
              />
            ) : null}
            {isPCCAvailable ? (
              <SendPCCReminderButton
                patientId={patientId ?? 0}
              />
            ) : null}
          </>
        ) : null
      )}
      disableGutters
      headerClasses={{
        root: '!px-2 !py-1 !min-h-[initial] !bg-gray-100 !text-gray-600 !font-semibold text-sm',
        content: '!m-0',
      }}
      detailsClasses={{ root: '!p-2 populate-form gap-form-row flex flex-col w-full' }}
    >
      <div className="flex w-full items-center gap-form-field">
        <Controller
          name="phoneNumber.phoneNumberWithAreaCode"
          control={control}
          rules={{ required: true, validate: validatePhone }}
          render={({ field, fieldState: { error } }) => (
            <Wrapper
              required
              error={!isNil(error)}
              className="w-1/3"
              label="Primary Phone"
              id="phone"
            >
              <PhoneInputWrapper
                {...field}
                error={!isNil(error)}
                className="w-full"
                isLoadingPhoneTag={isLoadingPhoneTag}
                phoneTag={primaryPhoneTag}
                id="phone"
                name="phone"
                fieldKey="phoneNumber.phoneNumberWithAreaCode"
              />
            </Wrapper>
          )}
        />
        <Controller
          name="otherPhoneNumber.phoneNumberWithAreaCode"
          control={control}
          rules={{ validate: validatePhoneIfSet }}
          render={({ field, fieldState: { error } }) => (
            <Wrapper
              className="w-1/3"
              error={!isNil(error)}
              label="Other Phone"
              id="other-phone"
            >
              <PhoneInputWrapper
                {...field}
                error={!isNil(error)}
                className="w-full"
                id="other-phone"
                name="other-phone"
                fieldKey="otherPhoneNumber.phoneNumberWithAreaCode"
              />
            </Wrapper>
          )}
        />
        <Controller
          name="email"
          control={control}
          rules={{ validate: validateEmailIfSet }}
          render={({ field, fieldState: { error } }) => (
            <Input
              {...field}
              error={!isNil(error)}
              label="Email"
              type="email"
              className="w-1/3"
              placeholder="Email"
              id="email"
            />
          )}
        />
      </div>
    </Accordion>
  );
}
